import { Ref } from 'vue';

/**
 * Races multiple promises against a timeout and sets a value if the timeout wins.
 * @param valueToBeSet - The value to be set if the timeout wins.
 * @param time - The timeout duration in milliseconds.
 * @param promisesToRace - An array of promises to race against the timeout.
 */
export async function racePromises(
  valueToBeSet: Ref | boolean,
  time: number,
  promisesToRace: Promise<any>[]
) {
  const setValue = (val: boolean | Ref) => {
    if (typeof valueToBeSet === 'boolean') {
      valueToBeSet = val;
    } else {
      valueToBeSet.value = val;
    }
  };
  const timeoutRacing = new Promise((resolve) =>
    setTimeout(() => resolve('timeout'), time)
  );

  const racingPromises = Promise.all(promisesToRace);

  const winner = await Promise.race([racingPromises, timeoutRacing]);
  if (winner === 'timeout') {
    setValue(true);
    await racingPromises;
    setValue(false);
  } else {
    setValue(false);
  }
}
